import Contacts from './contacts'

export default Contacts